import { render, staticRenderFns } from "./aidaClassStudentAdd.vue?vue&type=template&id=75cc6e3c&scoped=true&"
import script from "./aidaClassStudentAdd.vue?vue&type=script&lang=js&"
export * from "./aidaClassStudentAdd.vue?vue&type=script&lang=js&"
import style0 from "./aidaClassStudentAdd.vue?vue&type=style&index=0&id=75cc6e3c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75cc6e3c",
  null
  
)

export default component.exports